module.exports = __webpack_public_path__ + "img/training_course_1.281c2434.jpg";